export default {
    list: {
        title: 'Libreta de Direcciones',
        subtitle: 'Gestiona tus contactos',
        addContact: 'Añadir Contacto',
        loading: 'Cargando contactos...',
        allRoles: 'Todos los roles',
        searchPlaceholder: 'Buscar por nombre, apellido o email...',
        rolePlaceholder: 'Filtrar por rol',
        description: 'Lista de contactos en tu libreta de direcciones',
        headers: {
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Email',
            role: 'Rol',
            actions: 'Acciones',
        },
        noContacts: {
            title: 'No se encontraron contactos',
            message: 'Intenta modificar los filtros de búsqueda',
            emptyMessage: 'Comienza añadiendo tu primer contacto',
            addFirst: 'Añadir Primer Contacto',
        },
        modal: {
            addTitle: 'Añadir Contacto',
            editTitle: 'Editar Contacto',
            fields: {
                firstName: 'Nombre',
                firstNamePlaceholder: 'Ingresa nombre',
                lastName: 'Apellido',
                lastNamePlaceholder: 'Ingresa apellido',
                email: 'Email',
                emailPlaceholder: 'nombre@empresa.com',
                role: 'Rol',
            },
            cancel: 'Cancelar',
            save: 'Guardar Cambios',
            create: 'Añadir Contacto',
        },
        confirmDelete: {
            title: 'Confirmar eliminación',
            message: '¿Estás seguro de que quieres eliminar este contacto? Esta acción no se puede deshacer.',
            cancel: 'Cancelar',
            delete: 'Eliminar',
        },
    },
};

